import { getManagerCenterData, ManagerCenterDataParams } from 'services/api/getMangagerCenterData';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export const useGetManagerCenterData = (
    params: ManagerCenterDataParams,
    isEnabled = true,
    refetchInterval?: number
) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.managerCenterData,
        queryFn: () => getManagerCenterData(params),
        enabled: isEnabled,
        refetchInterval: refetchInterval,
    });

    return {
        managerCenterData: data,
        isManagerCenterDataLoading: isLoading,
        isManagerCenterDataFetching: isFetching,
        ...rest,
    };
};
